import React from 'react';
import { number, func, arrayOf, shape, string } from 'prop-types';

import { appConfig } from '../../../../config/customization';

const chooseColor = (years, year, firstColor, secondColor, thirdColor) => {
  if (years[0] === year) return firstColor;
  if (years[1] === year) return secondColor;
  return thirdColor;
};

function CustomBar({ x, y, width, height, fill, payload = {}, onClick, years }) {
  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      onClick={() => onClick(payload)}
      fill={chooseColor(years, payload.year, fill[0], fill[1], fill[2])}
      stroke={chooseColor(
        years,
        payload.year,
        appConfig.colors.historyFirstColorStroke,
        appConfig.colors.historySecondColorStroke,
        appConfig.colors.historyThirdColorStroke
      )}
      strokeWidth={2}
      strokeLinejoin="round"
    />
  );
}

CustomBar.propTypes = {
  x: number,
  y: number,
  width: number,
  height: number,
  fill: arrayOf(string),
  years: arrayOf(number),
  payload: shape({
    year: number
  }),
  onClick: func.isRequired
};

export default CustomBar;
